import { TmBaseError } from '@/core/error/tmBaseError'

export class TmCustomFieldError extends TmBaseError {
  public name = 'TmCustomFieldError'
}
